import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-deck-progress-loss-dialog',
  templateUrl: './deck-progress-loss-dialog.component.html',
  styleUrls: ['./deck-progress-loss-dialog.component.scss'],
  standalone: false,
})
export class DeckProgressLossDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DeckProgressLossDialogComponent>
  ) {}

  onProceed(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
